import styled from 'styled-components';

export const SalesStockContainer = styled.div`
  width: 100%;
  font-family: 'Inter', sans-serif;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

export const SalesSubHeader = styled.div`
  background: #fff;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px solid #E9ECEF;
  flex-wrap: wrap;
`;

export const StatsGroup = styled.div`
  display: flex;
  gap: 16px;
  margin-left: 4px;

  span {
    font-size: 11.5px;
    color: #696969;

    strong {
      color: #000;
      font-weight: 700;
    }
  }
`;

export const ViewDropdown = styled.div`
  position: relative;
`;

export const ViewButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 500;
  font-family: 'Inter', sans-serif;
  color: #696969;
  background: #EBEBEB;
  border: none;
  border-radius: 32px;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: #ddd;
  }
`;

export const ViewPanel = styled.div<{ $open: boolean }>`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  background: #fff;
  border: 1.5px solid #E9ECEF;
  border-radius: 12px;
  padding: 8px;
  min-width: 160px;
  box-shadow: 0 10px 32px rgba(0, 0, 0, 0.14);
  z-index: 500;
  display: ${props => props.$open ? 'flex' : 'none'};
  flex-direction: column;
  gap: 2px;
`;

export const ViewChip = styled.button<{ $active: boolean }>`
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-family: 'Inter', sans-serif;
  font-weight: ${props => props.$active ? 700 : 500};
  border: none;
  background: ${props => props.$active ? '#E6F4FB' : 'transparent'};
  color: ${props => props.$active ? '#0090D3' : '#696969'};
  cursor: pointer;
  text-align: left;

  &:hover {
    background: #f5f5f5;
  }
`;

export const FilterWrapper = styled.div`
  position: relative;
`;

export const FilterButton = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 500;
  font-family: 'Inter', sans-serif;
  color: ${props => props.$active ? '#0090D3' : '#696969'};
  background: ${props => props.$active ? '#E6F4FB' : '#EBEBEB'};
  border: ${props => props.$active ? '1.5px solid #A8D8EE' : 'none'};
  border-radius: 32px;
  cursor: pointer;
  white-space: nowrap;
  position: relative;

  &:hover {
    opacity: 0.86;
  }
`;

export const FilterBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #0090D3;
  color: #fff;
  font-size: 9px;
  font-weight: 800;
`;

export const FilterPanel = styled.div<{ $open: boolean }>`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  background: #fff;
  border: 1.5px solid #E9ECEF;
  border-radius: 12px;
  padding: 16px 18px;
  min-width: 360px;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  box-shadow: 0 10px 32px rgba(0, 0, 0, 0.14);
  z-index: 500;
  display: ${props => props.$open ? 'flex' : 'none'};
  flex-direction: column;
  gap: 13px;
`;

export const FilterRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const FilterLabel = styled.span`
  font-size: 10px;
  font-weight: 700;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const FilterChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const FilterChip = styled.button<{ $active: boolean }>`
  padding: 4px 11px;
  border-radius: 20px;
  font-size: 11.5px;
  font-weight: ${props => props.$active ? 700 : 500};
  border: 1.5px solid ${props => props.$active ? '#0090D3' : '#D8D8D8'};
  background: ${props => props.$active ? '#E6F4FB' : 'transparent'};
  color: ${props => props.$active ? '#0090D3' : '#696969'};
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  transition: all 0.12s;

  &:hover {
    border-color: #B8B8B8;
    color: ${props => props.$active ? '#0090D3' : '#000'};
  }
`;

export const FilterFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #E9ECEF;
  padding-top: 10px;
`;

export const HeaderActions = styled.div`
  display: flex;
  gap: 6px;
  margin-left: auto;
`;

export const ActionButton = styled.button`
  padding: 6px 12px;
  font-size: 11.5px;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  color: #696969;
  background: #EBEBEB;
  border: none;
  border-radius: 32px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;

  &:hover {
    opacity: 0.86;
  }
`;

export const PrimaryButton = styled(ActionButton)`
  background: #0090D3;
  color: #fff;
`;

export const TableCard = styled.div`
  background: transparent;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

export const TableToolbar = styled.div`
  padding: 11px 20px;
  border-bottom: 1px solid #E9ECEF;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const TableWrapper = styled.div`
  flex: 1;
  min-height: 0;
  overflow: auto;

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 0.35rem;

  thead th {
    padding: 9px 14px;
    text-align: left;
    font-size: 0.7rem;
    color: #696969;
    font-weight: 400;
    white-space: nowrap;
    background: #f5f5f5;
    letter-spacing: 0.3px;

    &:first-child {
      padding-left: 20px;
    }

    &.center {
      text-align: center;
    }
  }

  tbody tr {
    height: 2.4rem;
    background-color: #fff;
    transition: background 0.1s;

    &:hover:not(.group-row) {
      background: #f7f7f7;
    }
  }

  tbody td {
    padding: 9px 14px;
    font-size: 13px;
    vertical-align: middle;

    &:first-child {
      padding-left: 20px;
      border-top-left-radius: 0.5rem;
      border-bottom-left-radius: 0.5rem;
    }

    &:last-child {
      border-top-right-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    }

    &.center {
      text-align: center;
    }
  }
`;

export const GroupRow = styled.tr`
  td {
    background: #F0F6FF;
    padding: 8px 14px 8px 20px;
    cursor: pointer;
    user-select: none;

    &:first-child {
      border-top-left-radius: 0.5rem;
      border-bottom-left-radius: 0.5rem;
    }

    &:last-child {
      border-top-right-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    }
  }

  &:hover td {
    background: #E8F1FC;
  }
`;

export const ItemRow = styled.tr`
  td:first-child {
    padding-left: 36px;
  }
`;

export const Badge = styled.span<{ $variant: string }>`
  display: inline-flex;
  align-items: center;
  padding: 3px 9px;
  border-radius: 32px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;

  ${props => {
    const variants: Record<string, { bg: string; color: string }> = {
      green: { bg: '#D1FAE5', color: '#065F46' },
      yellow: { bg: '#FEF3C7', color: '#92400E' },
      blue: { bg: '#E6F4FB', color: '#005F8D' },
      purple: { bg: '#EDE9FE', color: '#5B21B6' },
      orange: { bg: '#FFEDD5', color: '#9A3412' },
      teal: { bg: '#CCFBF1', color: '#0F766E' },
      gray: { bg: '#F3F4F6', color: '#6B7280' },
    };
    const v = variants[props.$variant] || variants.gray;
    return `background: ${v.bg}; color: ${v.color};`;
  }}
`;

export const OpTag = styled.span`
  font-size: 11.5px;
  font-weight: 700;
  padding: 2px 9px;
  border-radius: 6px;
  background: #EDE9FE;
  color: #5B21B6;
  white-space: nowrap;
`;

export const PedTag = styled.span`
  font-size: 11.5px;
  font-weight: 600;
  padding: 2px 9px;
  border-radius: 6px;
  background: #F3F4F6;
  color: #374151;
  border: 1px solid #E5E7EB;
  white-space: nowrap;
`;

export const RefCode = styled.span`
  font-size: 12.5px;
  font-weight: 700;
  font-family: monospace;
`;

export const TamBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  padding: 2px 6px;
  border-radius: 5px;
  background: #E6F4FB;
  color: #0090D3;
  font-size: 11.5px;
  font-weight: 700;
  border: 1px solid #A8D8EE;
`;

export const ColorDot = styled.span<{ $hex: string }>`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.12);
  display: inline-block;
  flex-shrink: 0;
  background: ${props => props.$hex};
`;

export const QrButton = styled.button`
  background: none;
  border: 1.5px solid #D8D8D8;
  border-radius: 6px;
  padding: 3px 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  color: #999;
  transition: all 0.15s;

  &:hover {
    border-color: #0090D3;
    color: #0090D3;
    background: #E6F4FB;
  }
`;

export const GroupArrow = styled.span<{ $collapsed: boolean }>`
  font-size: 9px;
  color: #0090D3;
  transition: transform 0.15s;
  flex-shrink: 0;
  display: inline-block;
  transform: ${props => props.$collapsed ? 'rotate(-90deg)' : 'rotate(0)'};
  margin-right: 6px;
`;

export const ProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
`;

export const ProgressBar = styled.div`
  width: 44px;
  height: 3px;
  border-radius: 2px;
  background: #E5E7EB;
  overflow: hidden;
`;

export const ProgressFill = styled.div<{ $width: number; $color: string }>`
  width: ${props => props.$width}%;
  height: 100%;
  border-radius: 2px;
  background: ${props => props.$color};
`;

export const TableFooter = styled.div`
  padding: 9px 20px;
  border-top: 1px solid #E9ECEF;
  font-size: 11.5px;
  color: #999;
  display: flex;
  justify-content: space-between;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 56px 24px;
  color: #999;
`;

export const QrModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const QrModalContent = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  min-width: 300px;

  h3 {
    font-size: 14px;
    font-weight: 700;
    color: #000;
  }

  p {
    font-size: 12px;
    color: #696969;
    text-align: center;
  }

  button {
    padding: 8px 20px;
    border-radius: 32px;
    font-size: 12px;
    font-weight: 600;
    font-family: 'Inter', sans-serif;
    cursor: pointer;
    border: none;
    background: #0090D3;
    color: #fff;

    &:hover {
      opacity: 0.86;
    }
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 56px 24px;
  color: #999;
  font-size: 14px;
`;
